import * as React from "react";
import { useRecordContext, useResourceContext } from "react-admin";
import LaunchIcon from "@mui/icons-material/Launch";
import { useContext } from "react";
import { merchantCadena, merchantContext } from "../../DataProvider";
import { redirectToSociosMF } from "../../Resources/helpers/helpFunctions";
import MenuIcon from "@mui/icons-material/MoreHoriz";
import { ActionsDiv, MenuActionsDiv } from "../UI/Options/ActionsOptions";
import { useRef } from "react";
import { useState } from "react";
import { useOnClickOutside } from "../../Hooks/useOnClickOutside";
import { Box } from "@mui/material";
import { Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  link: {
    textDecoration: "none",
  },
  icon: {
    width: "0.6em",
    height: "0.6em",
    paddingLeft: 2,
  },
});

const OpenLink = ({
  source,
  prepend,
  cta = "",
  disabled,
  viewContext,
  ...props
}) => {
  const [showActions, setShowActions] = useState(false);
  const { getMerchant, setMerchantHabilitado } = useContext(merchantContext);
  const resource = useResourceContext();
  const record = useRecordContext();
  const ref = useRef();
  useOnClickOutside(ref, () => setShowActions(false));

  const isMultinegocio = resource == "multinegocio";
  const disabledPlanLink =
    resource == "planes" &&
    !record.payment_methods?.tarjeta &&
    record.payment_methods?.efectivo
      ? true
      : false;

  const handleClick = (e) => {
    e.stopPropagation();
    setShowActions(!showActions);
  };

  const handleRedirect = (e, prep) => {
    e.stopPropagation();
    redirectToSociosMF(`?displayedFilters=%7B"${prep.filter}"%3Atrue%7D&filter=%7B"${prep.filter}"%3A"${record?.id}"%7D&order=DESC&page=1&perPage=25&sort=last_subscription_date`);
  };

  const sellerMerchantParam = (merchId, link) =>
    `${link?.includes("?") ? "&" : "?"}seller_merchant=${merchId}`;

  const handleLink = (tipo, merchId, link) => {
    switch (true) {
      case resource === "corporativo":
        if (
          merchId !== "" &&
          merchId !== merchantCadena &&
          ["cadena-habilitadas", "cadena-sede"].includes(tipo)
        ) {
          return sellerMerchantParam(merchId, link);
        }
        return "";
      case resource === "planes":
        if (merchId !== "" && merchId !== merchantCadena) {
          return sellerMerchantParam(merchId, link);
        }
        return "";

      case resource === "abandoned":
        if (merchId !== "" && merchId !== merchantCadena) {
          return sellerMerchantParam(merchId, link);
        }
        return "";
      default:
        return "";
    }
  };

  const getBaseLink = (prep) => {
    if (prep.sourceLink) return record?.[prep.sourceLink] || null;
    if (record && source) return prep.link + record[source];
    if (record?.corporativo) return prep.link + record?.corporativo;
    return prep.link + record?.plan;
  };

  const getHref = (prep) => {
    const base = getBaseLink(prep);
    if (!base) return null;
    if (prep.sourceLink || (record && source)) {
      return prep.viewContext
        ? base + handleLink(record?.tipo, getMerchant()?.id, base)
        : base;
    }
    if (!record?.corporativo && resource === "abandoned") {
      return base + handleLink(null, getMerchant()?.id, base);
    }
    return base;
  };

  return disabledPlanLink || record?.archivado ? null : (
    <MenuActionsDiv ref={ref}>
      <MenuIcon
        sx={{
          color: "#64648C",
          borderRadius: "4px",
          cursor: "pointer",
          "&:hover": { backgroundColor: "#cfd8dc" },
        }}
        onClick={handleClick}
      />
      <ActionsDiv
        sx={{
          top: null,
          left: null,
          display: showActions ? "flex" : "none",
          transform: "translate(-50%, 50%)",
        }}
        id="actions_div"
      >
        {prepend.map((prep) =>
          prep.redirect ? (
            <>
              <Button
                sx={{
                  color: "grey",
                  "&:hover": {
                    color: "#000",
                  },
                }}
                fullWidth
                target="_blank"
                onClick={(e) => handleRedirect(e, prep)}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    style={{ fontSize: "11px" }}
                    color="primary"
                  >
                    {prep.label}
                  </Typography>
                  <LaunchIcon
                    style={{ width: "14px", backgroundColor: "priamry" }}
                    color="priamry"
                  />
                </Box>
              </Button>
            </>
          ) : !getHref(prep) ? null : (
            <>
              <Button
                sx={{
                  color: "grey",
                  "&:hover": {
                    color: "#000",
                  },
                }}
                fullWidth
                target="_blank"
                onClick={handleClick}
                href={getHref(prep)}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    style={{ fontSize: "11px" }}
                    color="primary"
                  >
                    {prep.label}
                  </Typography>
                  <LaunchIcon
                    style={{ width: "14px", backgroundColor: "priamry" }}
                    color="priamry"
                  />
                </Box>
              </Button>
            </>
          )
        )}
      </ActionsDiv>
    </MenuActionsDiv>
  );
};

export default OpenLink;
